import { useMemo, useState } from "react";
import { Heading } from "../Component";
import { Button } from "../Component";
import PreviewPDF from "./PreviewPdf";
import Table from "./Table";
import { CloudDownload } from "@material-ui/icons";

export default function PreviewTable(props) {
  const { goBack, backPath } = useMemo(() => {
    const data = { goBack: undefined, backPath: undefined };
    if (props.plan?.createMethod === "attachment") {
      data.backPath = "/lessonplans";
    } else {
      data.backPath = "/lessonplans";
    }
    return data;
  }, [props.plan]);

  return (
    <div className="lp-table">
      <Heading plan={props.plan} click={goBack} backPath={backPath}></Heading>
      {props.plan?.createMethod !== "attachment" ? (
        <>
          <div
            style={{
              width: "fit-content",
              display: "flex",
              gap: "20px",
              margin: "15px 0 auto auto",
            }}
          >
            <Button onClick={() => props.updateAction("download")}>
              <CloudDownload />
              Download
            </Button>
          </div>
          <Table
            showAll={true}
            extraValues={{
              Date: new Date(props.plan.startDate).toDateString(),
              Period: props.plan?.time || "Flexible",
              Grade: `${props.plan?.sectionId?.grade || ""}-${
                props.plan?.sectionId?.section || ""
              }`,
              Subject: props.plan?.subjectId?.name,
              Chapter: props.plan?.chapterId?.name || props.plan?.customChapter,
              Topic: props.plan?.topicId?.name || props.plan?.customTopic,
              "Sub Topic":props.plan?.moduleId?.name || props.plan?.customModule,
            }}
            plan={props.plan}
          />
        </>
      ) : (
        <PreviewPDF
          fileUrl={`https://xcell-cms-files.s3.amazonaws.com/${props.plan?.attachment}`}
        />
      )}
    </div>
  );
}
